var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChildrensToys = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Educative-Toys-Alphabet--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Educative Toys Alphabet Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9 11.5h6a2.75 2.75 0 0 0 2.75 -2.75v-6A2.75 2.75 0 0 0 15 0H9a2.75 2.75 0 0 0 -2.75 2.75v6A2.75 2.75 0 0 0 9 11.5Zm0.75 -7.25a2.25 2.25 0 0 1 4.5 0v4.5a0.75 0.75 0 0 1 -1.5 0V7a0.5 0.5 0 0 0 -0.5 -0.5h-0.5a0.5 0.5 0 0 0 -0.5 0.5v1.75a0.75 0.75 0 0 1 -1.5 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 5h0.5a0.5 0.5 0 0 0 0.5 -0.5v-0.25a0.75 0.75 0 0 0 -1.5 0v0.25a0.5 0.5 0 0 0 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.5h-6A2.75 2.75 0 0 0 0 15.25v6A2.75 2.75 0 0 0 2.75 24h6a2.75 2.75 0 0 0 2.75 -2.75v-6a2.75 2.75 0 0 0 -2.75 -2.75Zm-1.11 6A2.26 2.26 0 0 1 5.75 22h-1.5a0.76 0.76 0 0 1 -0.75 -0.75v-6a0.76 0.76 0 0 1 0.75 -0.75h1.5A2.26 2.26 0 0 1 7.64 18a0.48 0.48 0 0 0 0 0.52Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 19H5.5a0.5 0.5 0 0 0 -0.5 0.5v0.5a0.5 0.5 0 0 0 0.5 0.5h0.25a0.75 0.75 0 0 0 0 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 16H5.5a0.5 0.5 0 0 0 -0.5 0.5v0.5a0.5 0.5 0 0 0 0.5 0.5h0.25a0.75 0.75 0 0 0 0 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 12.5h-6a2.75 2.75 0 0 0 -2.75 2.75v6A2.75 2.75 0 0 0 15.25 24h6A2.75 2.75 0 0 0 24 21.25v-6a2.75 2.75 0 0 0 -2.75 -2.75Zm-2 8a0.75 0.75 0 0 1 0 1.5 3.75 3.75 0 0 1 0 -7.5 0.75 0.75 0 0 1 0 1.5 2.25 2.25 0 0 0 0 4.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChildrensToys);
export default ForwardRef;